import isMobile from './isMobile.js';

export const Mode = {
  Default: 'default',
  Embedded: 'embedded'
};

export const inspect = (mode) => {
  return {
    default: mode === Mode.Default,
    embedded: mode === Mode.Embedded
  };
};

// embedded style is applied only on non-mobile context,
// since those style is too big for small devices
export const isEmbeddedStyleEnabled = (mode) => {
  return inspect(mode).embedded && !isMobile();
};
